// extracted by mini-css-extract-plugin
module.exports = {"permanent":"Link--permanent--2R4Pa","link":"Link--link--24di1","link__active":"Link--link__active--Q8OcN","link__icon":"Link--link__icon--1yY1X","centered":"Link--centered--Zxup1"};